import { render, staticRenderFns } from "./SupportCenterView.vue?vue&type=template&id=70c22ce0&scoped=true"
import script from "./SupportCenterView.vue?vue&type=script&lang=js"
export * from "./SupportCenterView.vue?vue&type=script&lang=js"
import style0 from "./SupportCenterView.vue?vue&type=style&index=0&id=70c22ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c22ce0",
  null
  
)

export default component.exports